import React from 'react';
import { UsersIcon } from 'lucide-react';

/**
 * No ratings or buyer counts until there are real reviews.
 * Swap back to stars + faces once real, permissioned reviews exist.
 */
export function RatingProof() {
  return <div className="flex items-center gap-3 rounded-full border border-plum-line bg-plum px-4 py-2.5" data-id="element-241" data-mp="3bpshqw7lcznd">
      <span className="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-242" data-mp="3gi2eow74izz5">
        <UsersIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-243" data-mp="3lfluw1ndtmtq" />
      </span>
      <p className="text-[13px] leading-snug text-white/80" data-id="element-244" data-mp="3pgxm2blwmg41">
        Built for youth, middle school and high school coaches —{' '}
        <span className="font-semibold text-white" data-id="element-245" data-mp="3uhuzybzvsnzq">
          including first-year coaches who never wrestled.
        </span>
      </p>
    </div>;
}